'use client';

import Link from 'next/link';
import type { MouseEventHandler } from 'react';

interface BackButtonProps {
  /** Static destination, e.g. `/tools`. Ignored when `onClick` is set. */
  href?: string;
  /**
   * Click handler — when provided, renders as a `<button>` instead of a
   * link. Use this with `router.back()` to preserve browser history and
   * avoid re-fetching data on the previous page.
   */
  onClick?: MouseEventHandler<HTMLButtonElement>;
  ariaLabel?: string;
}

const baseClassName =
  'group flex shrink-0 items-center justify-center w-10 h-10 rounded-md border border-zinc-300 text-zinc-600 hover:border-zinc-900 hover:text-zinc-900 dark:border-zinc-700 dark:text-zinc-400 dark:hover:border-zinc-100 dark:hover:text-white transition-colors';

const ChevronLeft = (
  <svg
    className="w-5 h-5 transition-transform group-hover:-translate-x-0.5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
  </svg>
);

export default function BackButton({
  href = '/tools',
  onClick,
  ariaLabel = 'Go back',
}: BackButtonProps) {
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={baseClassName} aria-label={ariaLabel}>
        {ChevronLeft}
      </button>
    );
  }
  return (
    <Link href={href} className={baseClassName} aria-label={ariaLabel}>
      {ChevronLeft}
    </Link>
  );
}
